import { Bell, Check } from "lucide-react";
import { Button } from "~/components/ui/button";
import { usePushSetting } from "~/lib/use-push-setting";

export function NotifyPrompt({ title, body, showWhenOn = false }: { title: string; body: string; showWhenOn?: boolean }) {
  const { status, busy, error, turnOn } = usePushSetting();

  if (status === "unsupported") return null;

  if (status === "granted" && !error) {
    if (!showWhenOn) return null;
    return (
      <p className="text-muted-foreground flex items-center gap-2 text-[15px]">
        <Check className="text-foreground size-4.5 shrink-0" /> Notifications are on for this device.
      </p>
    );
  }

  if (status === "denied") {
    return (
      <p className="text-muted-foreground type-footnote">
        Notifications are blocked for this site. Allow them in your browser settings, then reload.
      </p>
    );
  }

  return (
    <div className="border-hairline bg-surface rounded-lg border p-4 text-left">
      <p className="text-[15px] font-medium">{title}</p>
      <p className="text-muted-foreground type-footnote mt-1">{body}</p>
      {error && (
        <p role="alert" className="text-destructive type-footnote mt-2">
          {error}
        </p>
      )}
      <Button variant="outline" className="mt-3 h-11 w-full text-[15px]" loading={busy} onClick={() => void turnOn()}>
        <Bell className="size-4.5" /> Turn on notifications
      </Button>
    </div>
  );
}
